import { render, staticRenderFns } from "./exam-evaluation-list.vue?vue&type=template&id=21c73e34&"
import script from "./exam-evaluation-list.vue?vue&type=script&lang=js&"
export * from "./exam-evaluation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports